import { useMemo } from "react";
import { useSelector } from "react-redux";
import * as authSelectors from "redux/auth/selectors";
import * as userSelector from "redux/user/selectors";
import { shouldShowFortuneWheel } from "../../../utils/wheel";

export const useShouldShowFortuneWheel = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { currency, id, firstDeposit } = useSelector(userSelector.all);

  return useMemo(
    () =>
      shouldShowFortuneWheel({
        isAuthenticated,
        currency,
        id,
        firstDeposit,
      }),
    [isAuthenticated, currency, id, firstDeposit],
  );
};
